export default "__VITE_ASSET__BoywXJTt__"